import { runtime } from '../../runtime/Runtime';
export class AppMessage {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get message() {
        return runtime.solidPackages.Lazy.classes.message;
    }
    async info(text) {
        await runtime.fetchPackages.Lazy;
        this.message.info(text);
    }
    async success(text) {
        await runtime.fetchPackages.Lazy;
        this.message.success(text);
    }
    async error(text) {
        await runtime.fetchPackages.Lazy;
        this.message.error(text);
    }
    async warning(text, time = undefined) {
        await runtime.fetchPackages.Lazy;
        this.message.warning(text, time);
    }
}
